import { selectOrderType } from '@repo/api-adapters/selectors/customer-assets.selectors';
import { selectServices } from '@repo/api-adapters/selectors/services.selectors';
import type { AssetDataType } from '@repo/types/asset';

import { getAppConfig } from '@/utils/window.utils';

import { isFeatureEnabled } from './feature';

export const isPickingListPdfEnabled = (data: AssetDataType | undefined): boolean => {
    if (!data || selectServices(data).length > 0) {
        return false;
    }

    return isFeatureEnabled(getAppConfig().feature.pickingListPdf, {
        assetType: data.assetType,
        orderType: selectOrderType(data),
    });
};
